import { ENDPOINTS } from 'utils/api/callApi'
import { generateApiActionTypes } from './generateActionTypes'

export const SHIPMENT_NOTE_TAGS = generateApiActionTypes('SHIPMENT_NOTE_TAGS')

export const getShipmentNoteTags = (shipmentId: string) => {
  const requestData = {
    endpoint: ENDPOINTS.users,
    group: 'note_users_autocomplete',
    params: {
      filters: { shipmentId },
    },
  }
  return {
    payload: {
      callApi: true,
      requestData,
      actionTypes: Object.keys(SHIPMENT_NOTE_TAGS),
    },
    type: 'TAGGING',
  }
}
